export interface Movie {
  id: string;
  title: string;
  type: "movie" | "tv";
  region: string;
  year: number;
  genres: string[];
  director: string;
  actors: string[];
  synopsis: string;
  poster: string;
  backdrop: string;
  rating: number;
  popularity: number;
  updatedAt: string;
  episodeCount?: number;
  currentEpisode?: number;
  duration: string;
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "星际远征",
    type: "movie",
    region: "中国",
    year: 2024,
    genres: ["科幻", "冒险", "动作"],
    director: "陈凯",
    actors: ["李昊然", "苏黎", "王浩然", "张韵"],
    synopsis:
      "一支人类深空远征舰队在穿越虫洞后偏离航线，坠入一片未知星系。面对资源枯竭与神秘文明的阻挠，船长老周必须带领船员在绝望中寻找回家的坐标，一场关于勇气与信念的星际远征就此展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20a%20science%20fiction%20film%20about%20deep%20space%20exploration%2C%20glowing%20blue%20planet%20and%20a%20lone%20astronaut%20silhouette%2C%20dramatic%20navy%20and%20orange%20color%20grading%2C%20moody%20lighting%2C%20professional%20commercial%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20deep%20space%20expedition%20fleet%20passing%20a%20giant%20glowing%20blue%20planet%2C%20vast%20starfield%2C%20dramatic%20navy%20and%20orange%20grading%2C%20movie%20key%20art%2C%20highly%20detailed%20atmospheric&width=1600&height=900&seq=tl-m1b&orientation=landscape",
    rating: 8.6,
    popularity: 9850,
    updatedAt: "2026-10-12",
    duration: "142分钟",
  },
  {
    id: "2",
    title: "暗夜追凶",
    type: "movie",
    region: "中国",
    year: 2023,
    genres: ["悬疑", "犯罪", "剧情"],
    director: "林川",
    actors: ["周牧", "刘颖", "赵磊"],
    synopsis:
      "连续发生的连环案件让整座城市陷入恐慌，退休刑警老郑被重新请回一线。在错综复杂的线索与真假难辨的证词之间，他一步步逼近真相，却发现真相比想象的更加令人心碎。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20with%20a%20detective%20silhouette%20under%20rain%20on%20a%20dark%20city%20street%2C%20deep%20navy%20tones%20with%20amber%20streetlight%20glow%2C%20tense%20mysterious%20mood%2C%20professional%20film%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20alley%20at%20night%20for%20a%20crime%20thriller%20film%20key%20art%2C%20wet%20pavement%20reflections%2C%20deep%20blue%20and%20amber%20grading%2C%20lonely%20detective%20figure%20in%20distance%2C%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m2b&orientation=landscape",
    rating: 8.2,
    popularity: 8720,
    updatedAt: "2026-10-08",
    duration: "128分钟",
  },
  {
    id: "3",
    title: "山海画卷",
    type: "movie",
    region: "中国",
    year: 2024,
    genres: ["奇幻", "古装", "冒险"],
    director: "许砚",
    actors: ["柳青", "顾南舟", "苏小小"],
    synopsis:
      "相传上古山海图卷能沟通天地，封印着上古神兽。少年画师岳岚意外获得残卷，为阻止恶势力解封灾祸，他踏上了一场穿越山川异域的奇幻旅程，也在其中找回了失落的自我。",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20adventure%20movie%20poster%20with%20a%20mythical%20scroll%20unfurling%20into%20mountains%20and%20clouds%2C%20elegant%20ink%20painting%20style%20with%20warm%20orange%20and%20deep%20blue%20accents%2C%20mystical%20atmosphere%2C%20professional%20poster%20design&width=400&height=600&seq=tl-m3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20misty%20clouds%20and%20glowing%20mythical%20beasts%2C%20ink%20wash%20painting%20aesthetic%2C%20warm%20golden%20and%20deep%20blue%20grading%2C%20cinematic%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=tl-m3b&orientation=landscape",
    rating: 8.4,
    popularity: 9130,
    updatedAt: "2026-10-10",
    duration: "135分钟",
  },
  {
    id: "4",
    title: "城市之光",
    type: "movie",
    region: "中国",
    year: 2022,
    genres: ["剧情", "家庭"],
    director: "何晓",
    actors: ["陈建国", "李梅", "王小雨"],
    synopsis:
      "一位普通的出租车司机在城市的夜晚见证了无数人的悲欢离合。当生活的重担压来，他依然选择用善意点亮每一段路程，让平凡的坚持成为这座城市最温暖的光。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20emotional%20drama%20movie%20poster%20of%20a%20taxi%20driver%20in%20a%20glowing%20city%20at%20night%2C%20gentle%20orange%20city%20lights%20against%20deep%20blue%20sky%2C%20hopeful%20human%20story%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20city%20skyline%20with%20warm%20glowing%20windows%20and%20a%20lone%20taxi%20on%20a%20bridge%2C%20hopeful%20emotional%20drama%20key%20art%2C%20deep%20blue%20night%20with%20orange%20city%20glow%2C%20cinematic%20and%20tender%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m4b&orientation=landscape",
    rating: 7.9,
    popularity: 6540,
    updatedAt: "2026-09-20",
    duration: "116分钟",
  },
  {
    id: "5",
    title: "极速风暴",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["动作", "赛车", "犯罪"],
    director: "Marcus Reed",
    actors: ["Jack Turner", "Elena Cruz", "Diego Ramos"],
    synopsis:
      "曾经的传奇车手在一次事故后隐退，却因好友被卷入地下赛车阴谋而重返赛道。引擎轰鸣之间，速度、背叛与救赎交织成一场惊心动魄的极速风暴。",
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20racing%20movie%20poster%20with%20a%20supercar%20drifting%20through%20neon%20streets%2C%20motion%20blur%20speed%20lines%2C%20deep%20blue%20night%20with%20orange%20sparks%2C%20explosive%20dramatic%20energy%2C%20professional%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Two%20supercars%20racing%20through%20a%20neon%20lit%20city%20at%20night%20with%20drifting%20smoke%20and%20sparks%2C%20action%20film%20key%20art%2C%20deep%20blue%20and%20orange%20grading%2C%20high%20speed%20dynamic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m5b&orientation=landscape",
    rating: 8.0,
    popularity: 8210,
    updatedAt: "2026-10-05",
    duration: "124分钟",
  },
  {
    id: "6",
    title: "温柔的谎言",
    type: "movie",
    region: "韩国",
    year: 2023,
    genres: ["爱情", "剧情"],
    director: "김지훈",
    actors: ["한소희", "이도현", "박보영"],
    synopsis:
      "为了守护一段即将破碎的感情，她选择说下一个温柔的谎言。多年后重逢，真相与真心在时光的缝隙里交缠，他们必须重新面对那份被藏起的爱意。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20movie%20poster%20with%20a%20couple%20standing%20apart%20under%20soft%20rain%2C%20tender%20melancholy%20mood%2C%20muted%20blue%20and%20warm%20orange%20accent%20grading%2C%20elegant%20minimal%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Two%20lovers%20silhouetted%20under%20a%20streetlamp%20in%20the%20rain%20at%20dusk%2C%20romantic%20Korean%20film%20key%20art%2C%20soft%20bokeh%20orange%20lights%20against%20deep%20blue%20evening%2C%20tender%20emotional%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m6b&orientation=landscape",
    rating: 7.8,
    popularity: 7320,
    updatedAt: "2026-09-28",
    duration: "108分钟",
  },
  {
    id: "7",
    title: "时间管理局",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["科幻", "悬疑", "动作"],
    director: "Sofia Lang",
    actors: ["Ryan Cole", "Mia Novak", "Aaron Bell"],
    synopsis:
      "在时间可以被合法篡改的未来，一名时间管理局特工发现自己的记忆正在被抹除。为了找回真实的过去，他必须在时间线崩塌前揭开管理局隐瞒百年的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20time%20travel%20movie%20poster%20with%20a%20man%20walking%20through%20a%20giant%20glowing%20clock%20and%20shattered%20timeline%20fragments%2C%20deep%20blue%20and%20electric%20orange%20grading%2C%20futuristic%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Futuristic%20control%20room%20with%20floating%20holographic%20timelines%20and%20a%20collapsing%20clock%2C%20sci%20fi%20film%20key%20art%2C%20deep%20blue%20with%20orange%20energy%20streaks%2C%20dramatic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m7b&orientation=landscape",
    rating: 8.3,
    popularity: 8890,
    updatedAt: "2026-10-07",
    duration: "131分钟",
  },
  {
    id: "8",
    title: "沙漠玫瑰",
    type: "movie",
    region: "中国",
    year: 2021,
    genres: ["剧情", "战争", "爱情"],
    director: "沈默",
    actors: ["林佳", "高晨", "周凯"],
    synopsis:
      "战火纷飞的年代，一位女护士在荒漠中坚守着一座临时医院。她用柔弱的肩膀撑起无数生命，也在漫天风沙中守护了一份跨越生死的爱情。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20drama%20movie%20poster%20with%20a%20woman%20in%20a%20harsh%20desert%20carrying%20a%20red%20rose%2C%20dusty%20orange%20sand%20against%20deep%20blue%20dusk%20sky%2C%20resilient%20emotional%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20desert%20landscape%20at%20golden%20hour%20with%20a%20small%20field%20hospital%20tent%20and%20distant%20smoke%2C%20war%20drama%20key%20art%2C%20warm%20orange%20sand%20and%20deep%20blue%20sky%2C%20epic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m8b&orientation=landscape",
    rating: 8.1,
    popularity: 5980,
    updatedAt: "2026-08-30",
    duration: "127分钟",
  },
  {
    id: "9",
    title: "深海回响",
    type: "movie",
    region: "英国",
    year: 2023,
    genres: ["悬疑", "惊悚", "科幻"],
    director: "Oliver Grant",
    actors: ["Emma Stone", "Tom Hardy", "Nora Blake"],
    synopsis:
      "深海科考站在海底探测到一段无法解释的回响信号。随着队员一个接一个陷入幻觉，站长意识到，他们唤醒的可能并不是人类曾经理解的东西。",
    poster:
      "https://readdy.ai/api/search-image?query=Underwater%20sci%20fi%20thriller%20movie%20poster%20with%20a%20diver%20facing%20a%20glowing%20unknown%20entity%20in%20deep%20dark%20water%2C%20eerie%20teal%20and%20deep%20blue%20grading%20with%20faint%20orange%20glow%2C%20tense%20atmosphere%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20research%20station%20glowing%20in%20dark%20ocean%20with%20strange%20bioluminescent%20formations%2C%20underwater%20thriller%20key%20art%2C%20deep%20blue%20abyss%20with%20orange%20submarine%20lights%2C%20mysterious%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m9b&orientation=landscape",
    rating: 7.7,
    popularity: 6890,
    updatedAt: "2026-09-15",
    duration: "118分钟",
  },
  {
    id: "10",
    title: "青春不散场",
    type: "movie",
    region: "中国",
    year: 2022,
    genres: ["青春", "爱情", "校园"],
    director: "苏晴",
    actors: ["陈星", "李可", "王泽熙"],
    synopsis:
      "毕业前夕，一群即将各奔东西的高中同学决定为青春举办一场盛大的告别。在笑声与泪水中，他们重新审视梦想、友情与那段青涩的暗恋。",
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20nostalgic%20youth%20movie%20poster%20with%20a%20group%20of%20students%20on%20a%20rooftop%20at%20sunset%2C%20warm%20orange%20sky%20and%20soft%20blue%20tones%2C%20joyful%20bittersweet%20mood%2C%20clean%20modern%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=High%20school%20campus%20lawn%20at%20golden%20sunset%20with%20students%20throwing%20graduation%20caps%2C%20youth%20film%20key%20art%2C%20warm%20orange%20and%20soft%20blue%20grading%2C%20joyful%20nostalgic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m10b&orientation=landscape",
    rating: 7.5,
    popularity: 5230,
    updatedAt: "2026-09-02",
    duration: "104分钟",
  },
  {
    id: "11",
    title: "龙纹宝藏",
    type: "movie",
    region: "中国",
    year: 2024,
    genres: ["冒险", "动作", "奇幻"],
    director: "郑拓",
    actors: ["吴峰", "孙曼", "刘一航"],
    synopsis:
      "一卷古老的龙纹图隐藏着失落王朝的宝藏。考古学者与身手不凡的探险家在秘境中破解机关，对抗觊觎宝藏的黑市势力，揭开一段尘封千年的历史。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20treasure%20hunting%20movie%20poster%20with%20an%20explorer%20holding%20a%20glowing%20dragon%20artifact%20inside%20an%20ancient%20temple%2C%20golden%20orange%20torchlight%20and%20deep%20blue%20shadows%2C%20thrilling%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20underground%20temple%20with%20glowing%20dragon%20carvings%20and%20hidden%20treasure%20chest%2C%20adventure%20film%20key%20art%2C%20warm%20orange%20torchlight%20against%20deep%20blue%20darkness%2C%20mysterious%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m11b&orientation=landscape",
    rating: 7.6,
    popularity: 7010,
    updatedAt: "2026-10-03",
    duration: "122分钟",
  },
  {
    id: "12",
    title: "雪国列车长",
    type: "movie",
    region: "日本",
    year: 2023,
    genres: ["悬疑", "剧情"],
    director: "佐藤健一",
    actors: ["山田凉介", "新垣结衣", "高桥一生"],
    synopsis:
      "一列驶向雪国的夜行列车在暴风雪中被迫停驶，乘客中却隐藏着一段不可告人的秘密。列车长必须在风雪封路前找出真相，否则下一站将是所有人的终点。",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20mystery%20drama%20movie%20poster%20with%20a%20train%20traveling%20through%20a%20snowstorm%2C%20lone%20warm%20window%20lights%20against%20deep%20blue%20snow%2C%20quiet%20tense%20melancholy%20mood%2C%20elegant%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20train%20cutting%20through%20a%20snowy%20mountain%20landscape%20in%20a%20blizzard%2C%20warm%20orange%20windows%20against%20deep%20blue%20snow%2C%20mystery%20film%20key%20art%2C%20lonely%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m12b&orientation=landscape",
    rating: 8.0,
    popularity: 6450,
    updatedAt: "2026-09-11",
    duration: "119分钟",
  },
  {
    id: "13",
    title: "无声告白",
    type: "movie",
    region: "中国",
    year: 2022,
    genres: ["家庭", "剧情"],
    director: "白露",
    actors: ["蒋雯", "刘佩", "陈昊"],
    synopsis:
      "一位失聪母亲独自抚养女儿长大，用无声的坚持教会她在喧嚣世界里勇敢发声。当女儿终于站上属于自己的舞台，母爱成为最响亮的那句告白。",
    poster:
      "https://readdy.ai/api/search-image?query=Touching%20family%20drama%20movie%20poster%20with%20a%20mother%20and%20daughter%20holding%20hands%20in%20soft%20window%20light%2C%20warm%20orange%20glow%20and%20gentle%20blue%20shadows%2C%20tender%20emotional%20mood%2C%20minimal%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20sunlit%20living%20room%20with%20a%20mother%20and%20daughter%20sharing%20a%20quiet%20moment%2C%20warm%20family%20drama%20key%20art%2C%20soft%20orange%20light%20with%20calm%20blue%20tones%2C%20tender%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m13b&orientation=landscape",
    rating: 8.5,
    popularity: 6120,
    updatedAt: "2026-08-22",
    duration: "110分钟",
  },
  {
    id: "14",
    title: "银河守卫",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["科幻", "动作", "冒险"],
    director: "Chris Nolan",
    actors: ["Sam Wilson", "Zoe Kravitz", "Leo Park"],
    synopsis:
      "当银河系边缘的防线被未知舰队突破，一支临时组建的守卫小队被派往最前线。他们性格各异、彼此看不顺眼，却必须携手守住人类最后的星际堡垒。",
    poster:
      "https://readdy.ai/api/search-image?query=Space%20action%20adventure%20movie%20poster%20with%20a%20team%20of%20armored%20heroes%20standing%20before%20a%20giant%20starship%2C%20deep%20blue%20space%20with%20orange%20energy%20shield%2C%20epic%20heroic%20mood%2C%20professional%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Massive%20space%20battle%20above%20a%20ringed%20planet%20with%20fighters%20and%20energy%20beams%2C%20sci%20fi%20action%20key%20art%2C%20deep%20blue%20cosmos%20with%20orange%20explosions%2C%20epic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m14b&orientation=landscape",
    rating: 8.1,
    popularity: 9340,
    updatedAt: "2026-10-11",
    duration: "138分钟",
  },
  {
    id: "15",
    title: "长安夜行",
    type: "movie",
    region: "中国",
    year: 2023,
    genres: ["古装", "悬疑", "动作"],
    director: "裴远",
    actors: ["顾清风", "苏浣", "穆云"],
    synopsis:
      "盛唐长安，一名负责夜巡的武侯在灯会上卷入一桩离奇命案。繁华灯火之下暗流涌动，他必须在一夜之间查明真凶，才能守住这座不夜之城的安宁。",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20action%20mystery%20movie%20poster%20with%20a%20swordsman%20on%20a%20lantern%20lit%20street%20at%20night%2C%20warm%20orange%20lantern%20glow%20and%20deep%20blue%20shadows%2C%20elegant%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-m15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Glamorous%20ancient%20Chinese%20capital%20city%20at%20night%20with%20thousands%20of%20glowing%20lanterns%2C%20martial%20arts%20film%20key%20art%2C%20warm%20orange%20light%20against%20deep%20blue%20night%2C%20grand%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-m15b&orientation=landscape",
    rating: 8.2,
    popularity: 7980,
    updatedAt: "2026-09-25",
    duration: "126分钟",
  },
  {
    id: "16",
    title: "都市迷情",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["都市", "情感", "剧情"],
    director: "孟凡",
    actors: ["江疏影", "王一博", "李沁"],
    synopsis:
      "三个来自不同背景的都市青年在快节奏的职场与生活中相遇。爱情、事业与理想不断碰撞，他们在迷惘与成长中，寻找属于自己的一席之地。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20TV%20drama%20poster%20with%20three%20young%20professionals%20in%20a%20glass%20office%20tower%2C%20sleek%20blue%20and%20warm%20orange%20city%20tones%2C%20stylish%20contemporary%20mood%2C%20clean%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20dusk%20with%20glass%20office%20towers%20and%20warm%20window%20lights%2C%20urban%20drama%20key%20art%2C%20deep%20blue%20and%20orange%20grading%2C%20stylish%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t16b&orientation=landscape",
    rating: 7.9,
    popularity: 8760,
    updatedAt: "2026-10-13",
    episodeCount: 40,
    currentEpisode: 32,
    duration: "45分钟/集",
  },
  {
    id: "17",
    title: "山河令传",
    type: "tv",
    region: "中国",
    year: 2023,
    genres: ["古装", "武侠", "剧情"],
    director: "顾长风",
    actors: ["龚俊", "张哲瀚", "周也"],
    synopsis:
      "江湖动荡，两派武林高手因一卷失传的令谱走到一起。他们在刀光剑影中并肩而行，既有家国大义，也有难言的知己情谊。",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20TV%20drama%20poster%20with%20two%20swordsmen%20back%20to%20back%20on%20a%20misty%20cliff%2C%20elegant%20ink%20and%20deep%20blue%20palette%20with%20orange%20sunset%20glow%2C%20heroic%20romantic%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20mountain%20landscape%20with%20two%20swordsmen%20facing%20off%2C%20misty%20peaks%20and%20falling%20petals%2C%20wuxia%20key%20art%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t17b&orientation=landscape",
    rating: 8.3,
    popularity: 9450,
    updatedAt: "2026-10-09",
    episodeCount: 36,
    currentEpisode: 36,
    duration: "44分钟/集",
  },
  {
    id: "18",
    title: "破案先锋",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["刑侦", "悬疑", "犯罪"],
    director: "郑毅",
    actors: ["张译", "王鸥", "李光洁"],
    synopsis:
      "一支由精英刑警组成的重案组，专攻疑难悬案。面对高智商犯罪与层层伪装，他们用缜密的推理与坚定的信念，让每一个真相水落石出。",
    poster:
      "https://readdy.ai/api/search-image?query=Police%20crime%20investigation%20TV%20drama%20poster%20with%20a%20detective%20team%20examining%20evidence%20on%20a%20case%20board%2C%20dark%20blue%20tones%20with%20orange%20spotlight%2C%20gripping%20tense%20mood%2C%20professional%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20police%20task%20force%20command%20center%20with%20detectives%20studying%20a%20giant%20evidence%20wall%2C%20crime%20drama%20key%20art%2C%20deep%20blue%20with%20orange%20highlights%2C%20intense%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t18b&orientation=landscape",
    rating: 8.4,
    popularity: 9020,
    updatedAt: "2026-10-14",
    episodeCount: 24,
    currentEpisode: 21,
    duration: "45分钟/集",
  },
  {
    id: "19",
    title: "医者仁心",
    type: "tv",
    region: "中国",
    year: 2023,
    genres: ["医疗", "剧情", "都市"],
    director: "白桦",
    actors: ["靳东", "马伊琍", "雷佳音"],
    synopsis:
      "急诊科里每天都在上演生死时速。一群医生在巨大的压力与抉择中坚守职业信仰，用专业与温度守护每一个被送进抢救室的生命。",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20TV%20series%20poster%20with%20doctors%20in%20scrubs%20in%20a%20bright%20hospital%20corridor%2C%20clean%20white%20and%20calm%20blue%20with%20warm%20orange%20accent%2C%20professional%20hopeful%20mood%2C%20modern%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Busy%20modern%20hospital%20emergency%20room%20with%20medical%20team%20in%20action%2C%20medical%20drama%20key%20art%2C%20clean%20blue%20and%20warm%20orange%20grading%2C%20intense%20yet%20hopeful%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t19b&orientation=landscape",
    rating: 8.1,
    popularity: 8120,
    updatedAt: "2026-09-30",
    episodeCount: 30,
    currentEpisode: 30,
    duration: "43分钟/集",
  },
  {
    id: "20",
    title: "硅谷风云",
    type: "tv",
    region: "美国",
    year: 2024,
    genres: ["商战", "剧情", "都市"],
    director: "David Fincher",
    actors: ["Andrew Garfield", "Amanda Seyfried", "Dev Patel"],
    synopsis:
      "一家初创公司在一夜之间成为硅谷焦点。天才创始人必须在资本的博弈、对手的围剿与团队的信任之间做出抉择，科技理想的代价远比他想象的沉重。",
    poster:
      "https://readdy.ai/api/search-image?query=Tech%20business%20drama%20TV%20series%20poster%20with%20a%20young%20founder%20silhouette%20against%20a%20glowing%20data%20skyline%2C%20deep%20blue%20and%20orange%20digital%20grid%20tones%2C%20intense%20ambitious%20mood%2C%20modern%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Futuristic%20tech%20campus%20at%20night%20with%20glass%20buildings%20and%20digital%20screens%2C%20business%20drama%20key%20art%2C%20deep%20blue%20with%20orange%20data%20glow%2C%20ambitious%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t20b&orientation=landscape",
    rating: 8.2,
    popularity: 7680,
    updatedAt: "2026-10-04",
    episodeCount: 12,
    currentEpisode: 10,
    duration: "55分钟/集",
  },
  {
    id: "21",
    title: "幻境游戏",
    type: "tv",
    region: "韩国",
    year: 2024,
    genres: ["科幻", "悬疑", "惊悚"],
    director: "박찬욱",
    actors: ["이정재", "김태리", "공유"],
    synopsis:
      "一款全感官虚拟现实游戏上线后，玩家接连在现实中失踪。程序员与调查记者联手潜入幻境深处，逐渐发现游戏背后隐藏着一个关于意识与控制的巨大阴谋。",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20sci%20fi%20thriller%20TV%20series%20poster%20with%20a%20player%20wearing%20a%20VR%20headset%20in%20a%20glowing%20surreal%20world%2C%20deep%20blue%20and%20electric%20orange%20grading%2C%20mind%20bending%20tense%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Surreal%20digital%20dreamscape%20landscape%20with%20floating%20geometric%20structures%2C%20sci%20fi%20thriller%20key%20art%2C%20deep%20blue%20with%20orange%20energy%20lines%2C%20mysterious%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t21b&orientation=landscape",
    rating: 8.5,
    popularity: 8210,
    updatedAt: "2026-10-06",
    episodeCount: 16,
    currentEpisode: 14,
    duration: "60分钟/集",
  },
  {
    id: "22",
    title: "校园风华",
    type: "tv",
    region: "中国",
    year: 2022,
    genres: ["青春", "校园", "爱情"],
    director: "夏晚",
    actors: ["谭松韵", "白敬亭", "关晓彤"],
    synopsis:
      "新学期的第一天，一群性格迥异的高中生因为一场社团招新走到一起。他们在课业、友情与懵懂心动的交织中，度过了最难忘的青春时光。",
    poster:
      "https://readdy.ai/api/search-image?query=Fresh%20youth%20campus%20TV%20drama%20poster%20with%20high%20school%20students%20in%20uniforms%20under%20cherry%20blossoms%2C%20soft%20pastel%20blue%20and%20warm%20orange%20light%2C%20bright%20cheerful%20mood%2C%20clean%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunny%20high%20school%20campus%20with%20students%20walking%20along%20a%20tree%20lined%20path%2C%20youth%20drama%20key%20art%2C%20warm%20orange%20afternoon%20light%20and%20soft%20blue%20sky%2C%20bright%20nostalgic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t22b&orientation=landscape",
    rating: 7.6,
    popularity: 6450,
    updatedAt: "2026-08-18",
    episodeCount: 28,
    currentEpisode: 28,
    duration: "42分钟/集",
  },
  {
    id: "23",
    title: "谍影重重",
    type: "tv",
    region: "中国",
    year: 2023,
    genres: ["谍战", "悬疑", "剧情"],
    director: "柳云龙",
    actors: ["柳云龙", "李小冉", "张鲁一"],
    synopsis:
      "战火年代，一名潜伏在敌营深处的地下工作者在危机四伏中传递情报。信任与背叛只在一念之间，他必须用生命守护那条连通胜利的秘密通道。",
    poster:
      "https://readdy.ai/api/search-image?query=Spy%20thriller%20TV%20drama%20poster%20with%20a%20man%20in%20a%20long%20coat%20and%20hat%20in%20a%20foggy%20old%20city%20alley%2C%20muted%20blue%20tones%20with%20warm%20orange%20lamp%2C%20tense%20mysterious%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t23&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Foggy%20wartime%20city%20street%20at%20night%20with%20a%20lone%20figure%20in%20a%20trench%20coat%2C%20spy%20thriller%20key%20art%2C%20deep%20blue%20with%20warm%20orange%20streetlight%2C%20suspenseful%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t23b&orientation=landscape",
    rating: 8.6,
    popularity: 8390,
    updatedAt: "2026-09-27",
    episodeCount: 32,
    currentEpisode: 32,
    duration: "45分钟/集",
  },
  {
    id: "24",
    title: "美食家日记",
    type: "tv",
    region: "日本",
    year: 2024,
    genres: ["生活", "美食", "剧情"],
    director: "是枝裕和",
    actors: ["松重丰", "石原里美", "坂口健太郎"],
    synopsis:
      "一位独自经营小餐馆的厨师，每天用一道道家常料理温暖着来往的客人。美食背后是一个个关于亲情、乡愁与治愈的动人故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20food%20drama%20TV%20series%20poster%20with%20a%20chef%20in%20a%20warm%20small%20restaurant%20surrounded%20by%20steaming%20dishes%2C%20warm%20orange%20lantern%20light%20and%20soft%20blue%20evening%2C%20healing%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t24&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20inviting%20Japanese%20izakaya%20interior%20with%20chef%20cooking%20and%20happy%20customers%2C%20food%20drama%20key%20art%2C%20cozy%20orange%20lamplight%20against%20deep%20blue%20evening%2C%20comforting%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t24b&orientation=landscape",
    rating: 8.0,
    popularity: 6890,
    updatedAt: "2026-10-02",
    episodeCount: 20,
    currentEpisode: 18,
    duration: "30分钟/集",
  },
  {
    id: "25",
    title: "星球拓荒者",
    type: "tv",
    region: "美国",
    year: 2023,
    genres: ["科幻", "冒险", "剧情"],
    director: "Denis Villeneuve",
    actors: ["Pedro Pascal", "Rebecca Ferguson", "Oscar Isaac"],
    synopsis:
      "人类首批火星拓荒者抵达陌生星球，却发现这里并不像资料中那样荒芜。面对未知环境与内部分歧，他们必须重新定义生存与文明的边界。",
    poster:
      "https://readdy.ai/api/search-image?query=Hard%20sci%20fi%20colonization%20TV%20series%20poster%20with%20astronauts%20standing%20on%20a%20red%20desert%20planet%20under%20a%20huge%20blue%20sky%2C%20dusty%20orange%20terrain%20with%20deep%20blue%20tones%2C%20epic%20awe%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t25&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20alien%20desert%20planet%20landscape%20with%20a%20colony%20dome%20and%20two%20moons%2C%20sci%20fi%20key%20art%2C%20warm%20orange%20sand%20and%20deep%20blue%20sky%2C%20epic%20isolated%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t25b&orientation=landscape",
    rating: 8.3,
    popularity: 7890,
    updatedAt: "2026-09-19",
    episodeCount: 10,
    currentEpisode: 10,
    duration: "58分钟/集",
  },
  {
    id: "26",
    title: "梦境诊疗所",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["悬疑", "奇幻", "剧情"],
    director: "蔡聪",
    actors: ["白宇", "周雨彤", "张新成"],
    synopsis:
      "在一家专门治疗噩梦的诊疗所里，年轻的心理医生能潜入病人的梦境。随着一桩桩离奇病例的出现，他逐渐触碰到一段与自己有关的隐秘往事。",
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20mystery%20fantasy%20TV%20series%20poster%20with%20a%20therapist%20silhouette%20dissolving%20into%20dream%20fragments%2C%20deep%20blue%20with%20soft%20orange%20glow%2C%20ethereal%20dreamlike%20mood%2C%20artistic%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t26&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dreamlike%20surreal%20landscape%20with%20floating%20doors%20and%20soft%20glowing%20orbs%2C%20fantasy%20mystery%20key%20art%2C%20deep%20blue%20with%20warm%20orange%20light%2C%20ethereal%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t26b&orientation=landscape",
    rating: 8.2,
    popularity: 8120,
    updatedAt: "2026-10-12",
    episodeCount: 18,
    currentEpisode: 15,
    duration: "46分钟/集",
  },
  {
    id: "27",
    title: "家族荣耀",
    type: "tv",
    region: "中国",
    year: 2022,
    genres: ["年代", "剧情", "家庭"],
    director: "张开宙",
    actors: ["刘奕君", "袁泉", "郭京飞"],
    synopsis:
      "一个历经风雨的大家族在时代洪流中沉浮。几代人的恩怨情仇、理想与传承，在岁月的打磨下沉淀为一段关于家与国的厚重记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Period%20family%20saga%20TV%20drama%20poster%20with%20a%20grand%20old%20mansion%20and%20family%20portrait%2C%20muted%20sepia%20orange%20and%20deep%20blue%20tones%2C%20nostalgic%20solemn%20mood%2C%20classic%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t27&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Historic%20Chinese%20family%20mansion%20courtyard%20at%20dusk%20with%20warm%20lanterns%2C%20period%20drama%20key%20art%2C%20muted%20orange%20and%20deep%20blue%20grading%2C%20nostalgic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t27b&orientation=landscape",
    rating: 8.4,
    popularity: 7320,
    updatedAt: "2026-08-25",
    episodeCount: 45,
    currentEpisode: 45,
    duration: "44分钟/集",
  },
  {
    id: "28",
    title: "律师风云",
    type: "tv",
    region: "美国",
    year: 2023,
    genres: ["律政", "剧情", "悬疑"],
    director: "Aaron Sorkin",
    actors: ["Michael Fassbender", "Jessica Chastain", "Mahershala Ali"],
    synopsis:
      "一家顶尖律所里没有永远的赢家。面对一桩桩棘手案件，天才律师们在法庭与良知之间游走，用一场场精彩辩论叩问正义的边界。",
    poster:
      "https://readdy.ai/api/search-image?query=Legal%20drama%20TV%20series%20poster%20with%20a%20confident%20lawyer%20in%20a%20courtroom%20before%20tall%20windows%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20powerful%20serious%20mood%2C%20premium%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t28&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20scene%20with%20a%20lawyer%20addressing%20the%20jury%2C%20legal%20drama%20key%20art%2C%20deep%20blue%20with%20warm%20orange%20spotlight%2C%20tense%20prestige%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t28b&orientation=landscape",
    rating: 8.5,
    popularity: 8050,
    updatedAt: "2026-09-22",
    episodeCount: 22,
    currentEpisode: 22,
    duration: "52分钟/集",
  },
  {
    id: "29",
    title: "甜心助理",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["爱情", "都市", "喜剧"],
    director: "吴桐",
    actors: ["赵露思", "陈飞宇", "丁禹兮"],
    synopsis:
      "一心想成为设计师的元气女孩，阴差阳错成了高冷总裁的私人助理。日常的斗嘴与磨合中，两颗心在不知不觉间悄悄靠近。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20comedy%20TV%20drama%20poster%20with%20a%20cheerful%20young%20assistant%20and%20a%20cool%20CEO%20in%20a%20bright%20office%2C%20warm%20orange%20and%20soft%20blue%20tones%2C%20sweet%20playful%20mood%2C%20clean%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t29&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunny%20modern%20company%20office%20with%20a%20playful%20young%20woman%20and%20a%20handsome%20boss%2C%20romantic%20comedy%20key%20art%2C%20warm%20orange%20and%20soft%20blue%20grading%2C%20sweet%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t29b&orientation=landscape",
    rating: 7.7,
    popularity: 8690,
    updatedAt: "2026-10-11",
    episodeCount: 24,
    currentEpisode: 20,
    duration: "41分钟/集",
  },
  {
    id: "30",
    title: "边境线",
    type: "tv",
    region: "中国",
    year: 2023,
    genres: ["军事", "动作", "剧情"],
    director: "刘猛",
    actors: ["王雷", "黄景瑜", "李念"],
    synopsis:
      "在环境恶劣的边境线上，一支边防小分队默默守护着家国的安宁。风雪、孤独与危险交织，他们用青春与热血，在界碑旁写下无悔的誓言。",
    poster:
      "https://readdy.ai/api/search-image?query=Military%20drama%20TV%20series%20poster%20with%20soldiers%20standing%20guard%20at%20a%20border%20monument%20in%20harsh%20snow%2C%20steel%20blue%20and%20warm%20orange%20sunrise%20tones%2C%20heroic%20solemn%20mood%2C%20cinematic%20poster%20design%2C%20highly%20detailed&width=400&height=600&seq=tl-t30&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Remote%20snowy%20border%20landscape%20at%20sunrise%20with%20soldiers%20patrolling%20along%20a%20ridge%2C%20military%20drama%20key%20art%2C%20cold%20blue%20snow%20with%20warm%20orange%20light%2C%20heroic%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tl-t30b&orientation=landscape",
    rating: 8.3,
    popularity: 7120,
    updatedAt: "2026-09-08",
    episodeCount: 30,
    currentEpisode: 30,
    duration: "45分钟/集",
  },
];